import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGamepadControlsDown"><Path d="M8 2H16V7.06066L12 11.0607L8 7.06066V2Z" fill="currentColor"/><Path d="M16.9393 8H22V16H16.9393L12.9393 12L16.9393 8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 16.9393V22H16V16.9393L12 12.9393L8 16.9393ZM14.5 17.5607V20.5H9.5V17.5607L12 15.0607L14.5 17.5607Z" fill="currentColor"/><Path d="M2 8V16H7.06066L11.0607 12L7.06066 8H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControlsDown;
